export function VollMark({ height = 24 }: Readonly<{ height?: number }>): React.JSX.Element {
  return (
    <svg
      height={height}
      viewBox="0 0 24 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-label="VOLL"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.3855 0.77931V17.2015C23.3855 18.7193 22.2869 20.0398 20.7676 19.9991C14.5853 19.8333 4.75361 15.9429 0.036039 1.00189C-0.120304 0.506738 0.25172 0 0.771618 0H4.11404C4.47214 0 4.78192 0.240588 4.88102 0.584223C6.14558 4.96933 10.1994 12.9995 17.8083 14.9061C18.1657 14.9956 18.503 14.7187 18.503 14.3508V0.779206C18.503 0.348805 18.8524 0 19.2834 0H22.6052C23.0362 0 23.3855 0.348909 23.3855 0.77931Z"
        fill="currentColor"
      />
    </svg>
  );
}
